var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiModel } from './api-model';
var Picture = /** @class */ (function (_super) {
    __extends(Picture, _super);
    function Picture(data) {
        var _this = _super.call(this, data) || this;
        _this.modified = false;
        return _this;
    }
    Picture.getFormats = function () {
        return ['original', 'format_16_9', 'format_4_3', 'format_3_4'];
    };
    Object.defineProperty(Picture.prototype, "empty", {
        get: function () {
            return !this.original && !this.format_16_9 && !this.format_3_4 && !this.format_4_3;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Picture.prototype, "hasOriginal", {
        get: function () {
            return this.original && (this.original.url || this.original.blob);
        },
        enumerable: true,
        configurable: true
    });
    Picture.prototype.getUrl = function (format, blob) {
        if (blob === void 0) { blob = false; }
        if (format === 'original') {
            return this.original.url ? this.original.url : this.original.blob;
        }
        if (this['format_' + format] && this['format_' + format].url) {
            return this['format_' + format].url;
        }
        else {
            if (blob && this['format_' + format] && this['format_' + format].blob) {
                return this['format_' + format].blob;
            }
            return null;
        }
    };
    Picture.prototype.changeUrl = function (url) {
        this.format_3_4 = null;
        this.format_4_3 = null;
        this.format_16_9 = null;
        this.original.url = url;
    };
    return Picture;
}(ApiModel));
export { Picture };



// WEBPACK FOOTER //
// ./src/app/models/picture.ts.pre-build-optimizer.js